// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__ADoso","options":"AnswerScale_options__FI5RZ","selected":"AnswerScale_selected__QSXMJ"};